import { ICommand, IDatasource, IDefineCommand, IQuery, IQueryMediator, key, t_key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { chain, filter, flatten, get, map, maxBy, minBy, sumBy } from 'lodash4';
import { APCourse } from '../../../../global/builders/ap_course_builder';
import { APProgramSlot } from '../../../../global/builders/ap_program_slot_builder';
import { APTerm } from '../../../../global/builders/ap_term_builder';
import { PlannedTerm } from '../../../../global/builders/planned_term_builder';
import { IAPCoursesDatasource } from '../../../../global/datasources/ap_courses_datasource';
import { IAPProgramSlotDatasource } from '../../../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../../../global/datasources/ap_terms_datasource';
import { APCourseServant } from '../../../../global/servants/ap_course_servant';
import { PreviewTermPlanModel } from '../models/preview_term_plan_model';

export class TermPlanPreviewQuery implements IQuery {
  private __result: any;

  constructor(
    QueryMediator: IQueryMediator,
    private ngPreviewTermPlanModel: PreviewTermPlanModel,
    private ngAPTermsDatasource: IAPTermsDatasource,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private appConfigModel: any
  ) {
    QueryMediator.registerQuery(this, ngPreviewTermPlanModel);
  }

  getMappedCourses() {
    const previewTermPlanData = this.ngPreviewTermPlanModel.read();
    return chain(previewTermPlanData.planned_courses)
      .map((course) => ({
        ...course,
        hoverTemplate: APCourseServant.buildHoverTemplate(course.course as APCourse)
      }))
      .value();
  }

  getMappedCourseGroups() {
    const previewTermPlanData = this.ngPreviewTermPlanModel.read();
    return chain(previewTermPlanData.planned_course_groups)
      .map((course_group: any) => course_group)
      .compact()
      .value();
  }

  getCreditsForTerm(termCourses: any, termCourseGroups: any[]) {
    const normalCoursesCreditSum = sumBy(termCourses, 'course.credits');
    return {
      min_credits: sumBy(termCourseGroups, 'min_credits') + normalCoursesCreditSum,
      max_credits: sumBy(termCourseGroups, 'max_credits') + normalCoursesCreditSum
    };
  }

  createTermForTermBox(term: APTerm, courses: any[], courseGroups: any[]) {
    const termCourses = filter(courses, { term: term.id });
    const termCourseGroups = filter(courseGroups, { term: term.id });
    return {
      planned_courses: termCourses,
      planned_course_groups: termCourseGroups,
      ...term,
      credits: this.getCreditsForTerm(termCourses, termCourseGroups)
    };
  }

  getProcessedTerms(courses: any, courseGroups: any) {
    const previewTermPlanData = { ...this.ngPreviewTermPlanModel.read() };
    previewTermPlanData.student_planned_terms = map(
      previewTermPlanData.student_planned_terms,
      (plannedTerm: PlannedTerm) => new PlannedTerm(plannedTerm)
    );
    const terms: APTerm[] = map(previewTermPlanData.student_planned_terms, 'term');
    return chain(terms)
      .map((term) => this.createTermForTermBox(term, courses, courseGroups))
      .sortBy('rank')
      .value();
  }

  run(): this {
    const courses = this.getMappedCourses();
    const courseGroups = this.getMappedCourseGroups();
    const terms = this.getProcessedTerms(courses, courseGroups);
    const hasDevReqCourses = !!_4.find(courses, { is_devreq: true });
    const showInfoMessage = !_4.isEmpty(terms) && hasDevReqCourses;
    const infoMessage = _4.get(this.appConfigModel, 'model.member_configs.autoloader_devreq_warning', '').trim();
    this.__result = {
      terms,
      hasDevReqCourses,
      infoMessage: showInfoMessage
        ? _4.isEmpty(infoMessage)
          ? 'This template includes developmental courses based on your placement results.'
          : infoMessage
        : ''
    };

    return this;
  }

  get result() {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngTermPlanPreviewQuery', TermPlanPreviewQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/queries/preview_term_plan_query.ts